/**
 * @file
 * @author zhousheng
 */
import InternalCheckbox from './Checkbox';
import ButtonCheckbox from './ButtonCheckbox';
import Group from './Group';
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.Button = ButtonCheckbox;
Checkbox.__ACUD_CHECKBOX = true;
export default Checkbox;